import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "@remix-run/react";
import { useEffect, useState, Fragment } from "react";


export default function SummaryLoginPopUp({ isSummaryPopupOpen, onPopupClose }: { isSummaryPopupOpen: boolean, onPopupClose: () => void }) {
    const [open, setOpen] = useState(isSummaryPopupOpen);
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.setItem("position", "book_summary");
    }, []);

    const handleClick = () => {
        setOpen(false)
        onPopupClose()
    }

    const handleKhClick = () => {
        /* mixpanel.track("resource_view_all", {
            position: "comingsoon_popup",
        }); */
        handleClick();
        navigate("/login");
    }

    return (
        <Transition show={open} as={Fragment}>
            <Dialog className="relative z-10" onClose={handleClick}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <TransitionChild
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
                                <div className="absolute right-0 top-0 hidden sm:block pt-6 pr-6">
                                    <button
                                        type="button"
                                        // className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        onClick={handleClick}
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon className="h-8 w-8" aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="flex flex-col gap-y-4 px-14 py-14 items-center">
                                    <div className="flex flex-col gap-y-3 items-center self-stretch justify-end">
                                        <DialogTitle as="h1" className="w-[408px] text-center text-subheading font-bold text-[#343434]">
                                            Hold up, bookworm!
                                        </DialogTitle>
                                        <p className="w-[436px] text-subtext font-medium text-center text-[#42526B]">
                                            Click below to login and unlock the book summary. Don&apos;t let your curiosity starve!
                                        </p>
                                        <button className="header-start-assessment mt-4" onClick={handleKhClick}>
                                            <p className="font-semibold"> Login </p>
                                        </button>
                                    </div>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}
